<script>
	import { createEventDispatcher, getContext, onMount } from 'svelte';

	import { keyToken, keyUser, ROLE_VIEWER } from '../../globals.js';

	const dispatch = createEventDispatcher();

	const UPPER_LIMIT_FACTOR = 1.25;

	const { getToken } = getContext(keyToken);
	const token = getToken();
	const { getUser } = getContext(keyUser);
	const user = getUser();

	let stock = {};
	let isin;
	let title = '';
	let limit;
	let type = 'upper';

	async function loadAssetDetail() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_asset.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ isin: isin })
		}).then(result => {
			if (result.ok) {
				console.log('Loaded asset detail successfully.');
				result.json().then(data => {
					console.log('Asset detail:', data);
					stock = data;
					title = data.name;
					limit = UPPER_LIMIT_FACTOR * stock.last / stock.factor;
				});
			} else {
				console.warn('Could not load asset detail of ISIN ' + isin, result.statusText);
				result.text().then(data => {
					console.log('Error:', data);
				});
			}
		});
	}

	async function addAlarm() {
		let detail = {
			isin: isin,
			limit: limit,
			type: type
		};
		console.log('Adding alarm', detail);

		await fetch('https://ostium.ch/api/borsalino/add_alarm.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify(detail)
		}).then(result => {
			if (result.ok) {
				console.log('Saved alarm successfully.');
				jQuery('#addAlarmDialog').modal('hide');
				result.json().then(data => {
					console.log('Alarm added:', data);
					dispatch('message', {
						type: 'success',
						text: data.message
					});
					dispatch('update', {
						type: 'alarms',
						text: data.message
					});
				});
			} else {
				console.warn('Could not add alarm for ISIN ' + isin, result.statusText);
				result.text().then(data => {
					console.log('Error:', data);
					dispatch('message', {
						type: 'error',
						text: data.error != null ? data.error : data.warning
					});
				});
			}
		});
	}

	function closeModal(event) {
		isin = null;
		stock = {};
		title = '';
		limit = null;
		type = 'upper';
		return event;
	}

	onMount(() => {
		jQuery('#addAlarmDialog').on('show.bs.modal', function (event) {
			let target =  event.relatedTarget;
			if (target != null && target.dataset != null && target.dataset['isin'] != null) {
				isin = target.dataset['isin'];
				loadAssetDetail();
			}
		});
		jQuery('#addAlarm').popover({
			container: 'body',
			placement: 'top'
		});
	});
</script>

<div class="modal fade" id="addAlarmDialog" data-backdrop="static" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content bg-dark">
			<div class="modal-header">
				<h5 class="modal-title">Add alarm for {title}</h5>
				<button type="button" class="close text-light" on:click={closeModal} data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body bg-dark text-light">
				<form>
					<fieldset class="form-group">
						<div class="row">
							<legend class="col-form-label col-sm-2 pt-0"></legend>
							<div class="col-sm-10">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" bind:group={type} id="upper" value="upper">
									<label class="form-check-label mr-3" for="upper">Upper</label>
									<input class="form-check-input" type="radio" bind:group={type} id="lower" value="lower">
									<label class="form-check-label" for="lower">Lower</label>
								</div>
							</div>
						</div>
					</fieldset>
					<div class="form-group row">
						<label for="limit" class="col-sm-2 col-form-label">Limit</label>
						<div class="col-sm-10">
							<input type="number" step="0.01" class="form-control bg-secondary text-light" id="limit" bind:value={limit}>
						</div>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" on:click={closeModal} data-dismiss="modal">Close</button>
				{#if user != null && user.role_id !== ROLE_VIEWER}
				<button type="button" class="btn btn-primary" on:click={addAlarm}>Save changes</button>
				{:else}
				<button type="button" class="btn btn-primary disabled" id="addAlarm" data-toggle="popover" data-content="Saving is not available to viewers.">Save changes</button>
				{/if}
			</div>
		</div>
	</div>
</div>
